import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { CBP_RATES_REFERENCE_DATA } from '../../../constants';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getCbpRatesReferenceData = createAsyncThunk(
  'stop/getCbpRatesReferenceData',
  async (params) => {
    const config = {
      headers: {
        Authorization: params,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(CBP_RATES_REFERENCE_DATA, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });
    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const cbpRatesReferenceSlice = createSlice({
  name: 'stop/cbpRatesReference',
  initialState: null,
  reducers: {
    resetCbpRatesReference: () => null,
  },
  extraReducers: {
    [getCbpRatesReferenceData.fulfilled]: (state, action) => action.payload,
  },
});

export const { resetCbpRatesReference } = cbpRatesReferenceSlice.actions;

export default cbpRatesReferenceSlice.reducer;
